import React from 'react'
import { ErrorBoundary, EnergyLabelBadge } from '@sainsburys-tech/bolt'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import { openAccordion } from '../../helpers/openAccordion'
import squeeze from '../../helpers/squeeze'
import hasKeys from '../../helpers/hasKeys'
import getBadge from '../../helpers/getBadge'
import * as Styled from './Badges.styles'
import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

const badgeData = {
  id: '#energy-rating',
  eventName: 'pdp_energyRatingAnchor',
  eventInfo: 'energy rating information',
  title: 'Energy Ratings',
  dataLength: 0
}

const energyLabelhandler = () => {
  openAccordion(badgeData.id)
  pushEventAndTrack({
    eventInfo: {
      eventName: badgeData.eventName,
      eventInfo: badgeData.eventInfo
    }
  })
}

const Badges = ({ badges = [], priorityMeta = {}, energyValue, energyPDF }) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()
  const numberOfBadges = badges.length
  if (!numberOfBadges && !energyValue) return null

  const prioritisedBadges = [
    getBadge(badges, priorityMeta, 'value'),
    getBadge(badges, priorityMeta, 'product'),
    getBadge(badges, priorityMeta, 'delivery')
  ].filter(hasKeys)

  const buildBadgeImage = (badge, key) => {
    const { badgeReference, badgeText } = badge.attributes
    const squeezedReference = squeeze(badgeReference)
    const src = `//media.4rgos.it/i/Argos/${squeezedReference}?$PDPBadge$`
    const srcSet = `//media.4rgos.it/i/Argos/${squeezedReference}?$PDPBadge$ 1x, //media.4rgos.it/i/Argos/${squeezedReference}?$PDPBadge2x$ 2x`
    const alt = badgeText || squeezedReference
    return (
      <Styled.Badge
        pdpV2={PDP_V2_FLAG}
        data-test='badge-image'
        src={src}
        srcSet={srcSet}
        data-badge-id={badge.id}
        alt={alt}
        key={key}
      />
    )
  }

  const badgeItems = prioritisedBadges.map(buildBadgeImage)

  return (
    <Styled.BadgeWrapper pdpV2={PDP_V2_FLAG} data-el='badges'>
      {!!numberOfBadges && badgeItems}
      {energyValue && !PDP_V2_FLAG && (
        <ErrorBoundary>
          <EnergyLabelBadge type={energyValue} linkUrl={energyPDF} onClick={energyLabelhandler} />
        </ErrorBoundary>
      )}
    </Styled.BadgeWrapper>
  )
}

export default Badges
